import { render } from "./NewTicketOptionForm.vue?vue&type=template&id=1d5678bb&scoped=true&ts=true"
import script from "./NewTicketOptionForm.vue?vue&type=script&lang=ts"
export * from "./NewTicketOptionForm.vue?vue&type=script&lang=ts"

import "./NewTicketOptionForm.vue?vue&type=style&index=0&id=1d5678bb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5678bb"]])

export default __exports__